module.exports = __webpack_public_path__ + "static/media/section_2_i_2.b3a26f0b.png";